import React from 'react';
import { Categories } from '../../category/components/Categories';
import { Extensions } from '../../extension/components/Extensions';
import { ViewModeSelector } from '../../viewMode/components/ViewModeSelector';
import { Layout, Button } from '@myua/kit';
import { useDispatch, useSelector } from 'react-redux';
import { getPermissions, getSidebarExpanded } from '../selectors';
import { getViewMode, getViewModeCollapsed } from '../../viewMode/selectors';
import { ViewMode } from '../../viewMode/model';
import { Project } from '../../project/components/Project';
import { Setting4 } from '@myua/icons/dist/linear16';
import * as appActions from '../actions';
import { getCategoriesCollapsed } from '../../category/selectors';
import { getExtensionsCollapsed } from '../../extension/selectors';
import { getProjectsCollapsed } from '../../project/selectors';
import { Permission } from '../../../../general/model';
import { SidebarDragHandler } from './SidebarDragHandler';
import { getSidebarWidth } from '../selectors';

export const LayoutSiderLeft = () => {
  const dispatch = useDispatch();
  const permissions = useSelector(getPermissions);
  const viewMode = useSelector(getViewMode);
  const sidebarExpanded = useSelector(getSidebarExpanded);
  const sidebarWidth = useSelector(getSidebarWidth);

  const categoriesCollapsed = useSelector(getCategoriesCollapsed);
  const extensionsCollapsed = useSelector(getExtensionsCollapsed);
  const viewModeCollapsed = useSelector(getViewModeCollapsed);
  const projectsCollapsed = useSelector(getProjectsCollapsed);

  if (!permissions[Permission['fs.assetlab_access']]) {
    return null;
  }

  return (
    <div className="al-app-layout-left">
      <Layout.Sider
        theme="light"
        collapsedWidth={64}
        width={sidebarWidth}
        collapsed={!sidebarExpanded}
      >
        <div className="al-app-layout-left__top">
          <Button
            className="al-app-layout-left__toggle"
            onClick={() =>
              dispatch(appActions.sidebarExpandedChanged({ sidebarExpanded: !sidebarExpanded }))
            }
            icon={<Setting4 />}
            title={sidebarExpanded ? 'Hide filters' : 'Show filters'}
            block
          >
            {sidebarExpanded ? 'Hide filters' : ''}
          </Button>
        </div>
        {sidebarExpanded ? (
          <div className="al-app-tree">
            <Project />
            <ViewModeSelector />
            {viewMode !== ViewMode.creatives && (
              <>
                <Categories />
                <Extensions />
              </>
            )}
          </div>
        ) : (
          <div className="al-app-layout-left__collapsed-content">
            <CollapsedTitle>{extensionsCollapsed}</CollapsedTitle>
            <CollapsedTitle>{categoriesCollapsed}</CollapsedTitle>
            <CollapsedTitle>{viewModeCollapsed}</CollapsedTitle>
            <CollapsedTitle>{projectsCollapsed}</CollapsedTitle>
          </div>
        )}
      </Layout.Sider>

      {sidebarExpanded ? <SidebarDragHandler /> : null}
    </div>
  );
};

const CollapsedTitle: React.FC<{ children: string }> = ({ children }) => {
  return <div title={children}>{children}</div>;
};
